import billing, { paymentUrl } from 'api/billing';
import { MessageInstance } from 'antd/es/message/interface';
import { TFunction } from 'i18next';
import { IDataRoom } from 'interfaces';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

const paymentType =
  window.REACT_APP_PAYMENT_TYPE !== 'REPLACE_REACT_APP_PAYMENT_TYPE'
    ? window.REACT_APP_PAYMENT_TYPE
    : process.env.REACT_APP_PAYMENT_TYPE || 'jusan';

export const runExtendTariff = async (
  room: IDataRoom,
  messageApi?: MessageInstance | null,
  t?: TFunction
): Promise<boolean> => {
  try {
    // const constraints = room?.tariff?.constraints;
    // const tariffConstraints = constraints
    //   ? {
    //       storage: constraints.storage,
    //       members: constraints.members,
    //       ...(constraints.rooms && { rooms: constraints.rooms }),
    //     }
    //   : null;

    const extendData: any = {
      tariff_data: {
        room_id: room?.id,
        tariff_name: null
      },
      payment_type: paymentType,
    };

    const { data: paymentData } = await billing.extendBillV2(extendData);

    if (paymentType === 'jusan') {
      const queryParams: string[] = [];
      for (const key in paymentData) {
        const value = paymentData[key] ? paymentData[key] : '';
        queryParams.push(`${key}=${value}`);
      }
      const correctParams = queryParams
        .join('&')
        .replace('&redirect=true', '%26redirect=true');
      window.location.href = `${paymentUrl}?${correctParams}`;
    } else {
      window.location.href = paymentData.payment_link;
    }
    return true;
  } catch (e) {
    messageApi?.error(t ? t('Header.error.extend') : 'Extend payment error');
    return false;
  }
};

export const runAwaitingPayment = async (
  room: IDataRoom,
  messageApi?: MessageInstance | null,
  t?: TFunction
): Promise<boolean> => {
  try {
    let paramsJSON: any;
    if (room?.tariff?.last_payment_intent?.payment_service === 'ios_iap') {
      const tariffJSON = {
        room_id: room.id,
        tariff_id: room?.tariff?.id,
        cost: room?.tariff?.cost,
        constraints: room?.tariff?.constraints,
        payment_type: paymentType,
      };
      const { data } = await billing.registerBill(tariffJSON);
      paramsJSON = data;
    } else {
      paramsJSON =
        room?.tariff?.last_payment_intent?.link &&
        JSON.parse(room?.tariff?.last_payment_intent?.link);
    }

    if (
      ['robokassa', 'ios_iap'].includes(
        room?.tariff?.last_payment_intent?.payment_service
      )
    ) {
      window.location.href = paramsJSON?.payment_link;
    } else {
      const queryParams: string[] = [];
      for (const key in paramsJSON) {
        const value = paramsJSON[key] ? paramsJSON[key] : '';
        queryParams.push(`${key}=${value}`);
      }
      const correctParams = queryParams
        .join('&')
        .replace('&redirect=true', '%26redirect=true');
      window.location.href = `${paymentUrl}?${correctParams}`;
    }
    return true;
  } catch (e) {
    messageApi?.error(t ? t('Header.error.register') : 'Payment error');
    return false;
  }
};

dayjs.extend(utc);

export const checkIsTariffEnded = (room?: IDataRoom | null): boolean => {
  if (!room?.tariff?.tariff_ends_at) return false;
  const dateEndedUtc = dayjs.utc(room.tariff.tariff_ends_at).valueOf();
  const currentDate = dayjs().valueOf();
  return dateEndedUtc - currentDate <= 0;
};

export const checkIsAwaitingPayment = (room?: IDataRoom | null): boolean => {
  return Boolean(room?.tariff?.tariff_name && room?.tariff?.tariff_ends_at === null);
};
